import { render, staticRenderFns } from "./SideRightHonor.vue?vue&type=template&id=e7f35ee4&scoped=true"
import script from "./SideRightHonor.vue?vue&type=script&lang=js"
export * from "./SideRightHonor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7f35ee4",
  null
  
)

export default component.exports